import { render, staticRenderFns } from "./PlateRecognitionDialog.vue?vue&type=template&id=3bfa86e0"
import script from "./PlateRecognitionDialog.vue?vue&type=script&lang=js"
export * from "./PlateRecognitionDialog.vue?vue&type=script&lang=js"
import style0 from "./PlateRecognitionDialog.vue?vue&type=style&index=0&id=3bfa86e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports